module.exports = __webpack_public_path__ + "img/Yakiyan.8c2e2658.svg";